module.exports = __webpack_public_path__ + "static/media/fsyuce002.5ae19570.png";